export enum ClientPresentationBundleTypes {
  ENTITY = 'entity',
  ESTATE_WATERFALL = 'estatewaterfall',
}
